export default [
    {
        id: 'measure-record-points',
        type: 'circle',
        source: 'measure-records',
        paint: {
            'circle-radius': 2,
            'circle-color': '#ddddcc',
            'circle-stroke-color': [
                'case',
                ['boolean', ['feature-state', 'hover'], false],
                '#ff0000',
                '#ffffff',
            ],
            'circle-stroke-width': [
                'case',
                ['boolean', ['feature-state', 'hover'], false],
                2,
                1,
            ],
        },
        filter: [
            'all',
            ['==', ['get', 'isVisible'], true],
            ['==', ['geometry-type'], 'Point'],
        ],
        minzoom: 12,
    },
    {
        id: 'measure-record-linestring-halo',
        type: 'line',
        source: 'measure-records',
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
        },
        paint: {
            'line-color': '#222222',
            'line-width': 2,
            'line-opacity': 0.8,
        },
        filter: [
            'all',
            ['==', ['get', 'isVisible'], true],
            ['==', ['geometry-type'], 'LineString'],
        ],
        minzoom: 12,
    },
    {
        id: 'measure-record-linestring',
        type: 'line',
        source: 'measure-records',
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
        },
        paint: {
            'line-color': [
                'case',
                ['boolean', ['feature-state', 'hover'], false],
                '#ff0000',
                '#eeddee',
            ],
            'line-width': 2,
            'line-dasharray': [0.1, 2.5],
        },
        filter: [
            'all',
            ['==', ['get', 'isVisible'], true],
            ['==', ['geometry-type'], 'LineString'],
        ],
        minzoom: 12,
    },
    {
        id: 'measure-record-polygon-outline-halo',
        type: 'line',
        source: 'measure-records',
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
        },
        paint: {
            'line-color': '#222222',
            'line-width': 2,
            'line-opacity': 0.8,
        },
        filter: [
            'all',
            ['==', ['get', 'isVisible'], true],
            ['==', ['geometry-type'], 'Polygon'],
        ],
        minzoom: 12,
    },
    {
        id: 'measure-record-polygon-outline',
        type: 'line',
        source: 'measure-records',
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
        },
        paint: {
            'line-color': [
                'case',
                ['boolean', ['feature-state', 'hover'], false],
                '#ff0000',
                '#eeddee',
            ],
            'line-width': 2,
            'line-dasharray': [0.1, 2.5],
        },
        filter: [
            'all',
            ['==', ['get', 'isVisible'], true],
            ['==', ['geometry-type'], 'Polygon'],
        ],
        minzoom: 12,
    },
    {
        id: 'measure-record-polygon',
        type: 'fill',
        source: 'measure-records',
        paint: {
            'fill-color': [
                'case',
                ['boolean', ['feature-state', 'hover'], false],
                '#ff0000',
                '#000000',
            ],
            'fill-opacity': [
                'case',
                ['boolean', ['feature-state', 'hover'], false],
                0.5,
                0.4,
            ],
        },
        filter: [
            'all',
            ['==', ['get', 'isVisible'], true],
            ['==', ['geometry-type'], 'Polygon'],
        ],
        minzoom: 12,
    },
    {
        id: 'measure-record-point-measurement',
        type: 'symbol',
        source: 'measure-records',
        layout: {
            'symbol-placement': 'point',
            'text-field': ['get', 'totalMeasurementLabel'],
            'text-size': [
                'interpolate',
                ['exponential', 0.5],
                ['zoom'],
                14,
                6,
                20,
                12,
            ],
        },
        paint: {
            'text-color': '#eeeeee',
            'text-halo-color': 'rgba(0,0,0,0.8)',
            'text-halo-width': 1,
        },
        style: {
            glyphs: '',
        },
        filter: [
            'all',
            ['==', ['get', 'isVisible'], true],
            ['==', ['geometry-type'], 'Point'],
        ],
        minzoom: 16,
    },
    {
        id: 'measure-record-line-measurement',
        type: 'symbol',
        source: 'measure-records',
        layout: {
            'symbol-placement': 'line-center',
            'text-field': ['get', 'measurementLabel'],
            'text-size': [
                'interpolate',
                ['exponential', 0.5],
                ['zoom'],
                14,
                6,
                20,
                12,
            ],
            'icon-allow-overlap': true,
            'symbol-spacing': 150,
            'text-pitch-alignment': 'viewport',
            'text-rotation-alignment': 'viewport',
        },
        paint: {
            'text-color': '#eeeeee',
            'text-halo-color': 'rgba(0,0,0,0.8)',
            'text-halo-width': 1,
        },
        filter: [
            'all',
            ['==', ['get', 'isVisible'], true],
            ['==', ['geometry-type'], 'LineString'],
        ],
        minzoom: 16,
    },
    {
        id: 'measure-record-polygon-measurement',
        type: 'symbol',
        source: 'measure-records',
        layout: {
            'symbol-placement': 'point',
            'text-field': ['get', 'measurementLabel'],
            'text-size': [
                'interpolate',
                ['exponential', 0.5],
                ['zoom'],
                14,
                6,
                20,
                12,
            ],
        },
        paint: {
            'text-color': '#eeeeee',
            'text-halo-color': 'rgba(0,0,0,0.6)',
            'text-halo-width': 1,
        },
        style: {
            glyphs: '',
        },
        filter: [
            'all',
            ['==', ['get', 'isVisible'], true],
            ['==', ['geometry-type'], 'Polygon'],
        ],
        minzoom: 16,
    },
];
